import React, { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {connect} from 'react-redux';
import ROUTES from './../../constants/routes';
import Config from './../../constants/config';
import './../../css/acc-link.css';
import './../../global/css/global.css';
import './../../global/css/acc-link-header-footer.css';
import './../../css/main.css'
import lock from './../../images/lock.png';
import alert from './../../images/alert.png';
import FormValidator from './FormValidator';
import spinner from './../../Spinnerimage.gif';
import {HttpStatusCode, ResultCodes, Messages} from './../../constants/utilities';
import AxiosDataService from '../../services/AxiosDataService';
import {OnLoginPageLoad , OnLoginSubmit,ForgotUserPassword,OnLoginTechDiff,OnLoginTryAgain, OnLoginCancel, OnLoginErrorEvent, OnLoginClientErrorEvent, OnTechDiffPageLoad} from './../../components/SiteCat/SiteCat'
import {getMerchantDataLoginPage,onUserCancel,onServerError} from './../../constants/merchantData';
import { Buffer } from 'buffer';


class Login extends Component {
  constructor(props, context) {
    super(props, context);

    this.validator = new FormValidator([
      {
        field: 'userName',
        method: 'isEmpty',
        validWhen: false,
        message: 'Please enter User ID'
      },
      {
        field: 'password',
        method: 'isEmpty',
        validWhen: false,
        message: 'Please enter Password',
        isEmptyValid: false
      }

    ]);

    this.state = {
      userName: "",
      password: "",
      jwtToken: Object,
      doRedirect: false,
      validation: this.validator.valid(),
      noUserNameError: true,
      errorMessage: "",
      pageName: "",
      showError: false,
      disabled: false,
      isLoaded: false,
      hyperLink: false,
      contactno:false,
      cancelUrl:"",
      submitted: false,
      setAsPrefferdUrl: "",
      migrationMessage:false,
      forgetPasswordDisable:false
    }
  };

  componentWillMount() {
    var queryObject = {};
    // read location and split it 
    var queryStringData = (window.location.search !== "") ? window.location.search : `?code=''`;
    var queryList = ((queryStringData).split('?')[1]).split('&');
    // create object 
    queryList.map(function (val) {
      let temArray = val.split('=');
      return queryObject[temArray[0]] = temArray[1];
    }
    );

    const pathNameData = window.location.pathname;
    var merchantData = pathNameData.split(/[\s/]+/);
    const merchantName = merchantData[merchantData.length-1].split('&')[0];
          this.setState({
          merchantName: merchantName
    });
    
  }
  componentDidMount() {     
    var queryObject = {};
    // read location and split it 
    var queryStringData = (window.location.search !== "") ? window.location.search : '?code=null';
    var queryList = ((queryStringData).split('?')[1]).split('&');
    // create object 
    queryList.map(function (val) {
      let temArray = val.split('=');
      return queryObject[temArray[0]] = temArray[1];
    }
    );

    const pathNameData = window.location.pathname;
    var merchantData = pathNameData.split(/[\s/]+/);
    const authcodeData = queryObject.code;
    const merchantName = merchantData[merchantData.length-1].split('&')[0];
    var cancelUrlFromParam = "";
    if(queryObject.cancelurl !="" && queryObject.cancelurl !=null && queryObject.cancelurl != 'undefined' ){
      cancelUrlFromParam= decodeURIComponent(queryObject.cancelurl);
    }

    const options={
      url: window.location.origin + '/web/cardissuer/accntlinking/getjwttoken/' + Config.merchantName,
      method: 'get',
      flag:'app'
    }
    AxiosDataService.fetch(options).then(response => {
      console.log("Login Page-HyperlinkTrue1");
        // return response.json();
        this.setState({
          jwtToken: response.data,
          cancelUrl: response.data.cancelUrl,
          setAsPrefferdUrl: response.data.setAsPrefferdUrl,
          authcode: authcodeData,
          merchantName: merchantName       
      });
      
      const jwtdata= response.data;
      const cancelUrl = response.data.cancelUrl;
      const setAsPrefferdUrl = response.data.setAsPrefferdUrl
      this.props.dispatch({
        type:'ADD_JWT_DATA',
        jwtdata,
        merchantName,
        authcodeData,
        cancelUrl,
        setAsPrefferdUrl
      });
    });
    OnLoginPageLoad(this.state.merchantName);
  };

  componentWillUnmount() {

    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function (event) {
      window.history.go(1);
    };

  };
  handleInputChange = event => {
    event.preventDefault();
    if(event.target.name === "userName"){
      this.setState({
        [event.target.name]: event.target.value.trim()
      })
    }else{
      this.setState({
        [event.target.name]: event.target.value
      })
    }

  }

  OnForgotUsername=()=>{
    ForgotUserPassword(this.state.merchantName)
    window.open(Config.ForgotUserName,'_blank');

  }
  OnForgotPassword=()=>{
    ForgotUserPassword(this.state.merchantName);
    window.open(Config.ForgotPassword,'_blank');
  }

  OnprivacyLink = () => window.open(Config.Privacy,'_blank');
  
  OntermsUse = () => window.open(Config.TermsOFUse,'_blank');
  
  handleKeyPress = (event) => {

    if (event.key === 'Enter') {
      if(!this.state.hyperLink) {
        this.handleFormSubmit();
      }else{
        return false;
      }
    }
  }
  handleCancel = event => {
    OnLoginCancel(this.state.hyperLink, this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrl,
      authCode: this.state.authcode 
    }
    onUserCancel(data);
  }
  OnTryAgain = event => {
    OnLoginTryAgain(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.jwtToken.cancelUrl,
      authCode: this.state.authcode 
    }
    onServerError(data);
  }
  handleFormSubmit = event => {

   
    const validation = this.validator.validate(this.state)
    this.setState({
      validation,
      isLoaded: true,
      submitted: true
    });

    if (validation.userName.message === "" && validation.password.message === "") {
      OnLoginSubmit(this.state.merchantName);
      Config.Backend_URL = this.state.jwtToken.pwdApiUrl
      Config.JWT_Token = this.state.jwtToken.jwtToken
      Config.cancelRedirect= this.state.jwtToken.cancelUrl
      Config.SetAsPrefferd= this.state.jwtToken.setAsPrefferdUrl
      Config.merchantName = this.state.merchantName
      let randomstring = require('random-string');
      let buff = Buffer.from(this.state.password);
      let password_base64data = buff.toString('base64');
      

      let userData = {
        userName: this.state.userName,
        password: password_base64data,
        merchantName: this.state.merchantName,
        authCode: this.state.authcode,
        userTypeCode: Config.userTypeCode,
        sessionID:  this.props.posts.sessionID 
      }

      const self = this;
        const options = {
        url: "fetchAcctSummaryByUserInfo",// + Config.env,
        method: 'post',
        timeout: 15000,
        headers: {
          "Access-Control-Allow-Origin": "*",
          //"HTTP_AUTH_TOKEN":  self.state.jwtToken.jwtToken,
          'Content-Type': 'application/json',
          "REQUEST_ID": randomstring({ length: 20 })
        },
        data: userData
      };
        AxiosDataService.fetch(options).then((responsedata) => {
          self.setState({
            showError: false,
            errorMsg: "",
            isLoaded: false,
            contactno:false,
            hyperLink: false
          });

       

          let response=responsedata.data;
          if(response.responseOutput == null && responsedata.request.responseURL !== ""){
            window.location.replace(responsedata.request.responseURL);
          }
          if (response.responseOutput.returnCode === "0" || response.responseOutput.returnCode === "112" || response.responseOutput.returnCode === "113") {
            if (response.resultCode === ResultCodes.ACCT_ALREADY_LINKED) {
              self.setState({ pageName: "AccountAlreadyLinkedPage" });
              self.setState({ doRedirect: true });
            } else if (response.resultCode === ResultCodes.NO_ELIGIBLE_ACCT) {
              self.setState({ pageName: "NoEligibleAccountPage" });
              self.setState({ doRedirect: true });
            } else if (response.resultCode === ResultCodes.MAX_PROVISION_LIMIT) {
              self.props.dispatch({
                type:'PROVISIONING_LIMIT',
                provisioningLimitValue: response.provisioningLimit,
                });
              self.setState({ pageName: "MaxProvisionLimitPage" });
              self.setState({ doRedirect: true });
            } else if (response.resultCode === ResultCodes.RA_DENY) {
              self.setState({ pageName: "RaDeny" });
              self.setState({ doRedirect: true });
            } else if (response.resultCode === ResultCodes.USER_NOT_REGISTERED || response.resultCode === ResultCodes.LAST_SIGNON_ATTEMPT) {
              OnLoginErrorEvent(Messages.INFORM_NOT_MATCH, this.state.merchantName);
              self.setState({
                doRedirect: false,
                showError: true,
                errMsg: Messages.INFORM_NOT_MATCH
              });
            }else if(response.resultCode === ResultCodes.MIGRATIONSTATUS_MIGRATED){
              OnLoginTechDiff(this.state.merchantName);
              self.setState({
                doRedirect:false,
                migrationMessage: true,
                disabled:true,
                hyperLink:true,
                forgetPasswordDisable: true,
                userName:"",
                password:""
              });
             }else if(response.resultCode === ResultCodes.MIGRATIONSTATUS_INPROGRESS){
              self.setState({pageName: "TechDiff"});
              self.setState({doRedirect:true});
            }else if(response.resultCode === ResultCodes.INVALID_EXT_STATUS) {
              OnLoginErrorEvent(Messages.INVALID_EXT_STATUS, this.state.merchantName);
              self.setState({
                doRedirect: false,
                showError: true,
                errMsg: Messages.INVALID_EXT_STATUS
              });
            }else if (response.resultCode === ResultCodes.ACCT_LOCKED) {
              OnLoginErrorEvent(Messages.ACCT_LOCKED+"Please call 1-800-347-2683 to get your account unlocked.", this.state.merchantName);
              self.setState({
                doRedirect: false,
                showError: true,
                contactno: true,
                errMsg: Messages.ACCT_LOCKED
              });
            } else if(response.resultCode === ResultCodes.CONTACT_SELECTION_PAGE){
                self.props.dispatch({
                    type:'LINKFI_RESPONSE',
                    response,
                    selectedCarddigits: responsedata.data
                   
                });
                self.setState({ pageName: "ContactChannels" });
                self.setState({ doRedirect: true });
            
            }else if(response.resultCode === ResultCodes.CID_PAGE){
                self.props.dispatch({
                        type:'LOGIN_RESPONSE',
                        response,
                        linkId: responsedata.data,
                        last4Digit:response.last4AcctNbr
                    });
                self.setState({ pageName: "CardSecurePage" });
                self.setState({ doRedirect: true });
            
            }else if(response.resultCode === ResultCodes.NO_CONTACT_CHNL){
                self.setState({ pageName: "NoContactChannel" });
                self.setState({ doRedirect: true });
            
            }else if(response.resultCode === ResultCodes.ACCT_LINKING_PAGE){

              let resData = response.eligibleAccountVO;

              if (resData.length === 1) {
                self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response
                  });
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
              } else if (resData.length > 1) {
                self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response
                  });
                self.setState({ pageName: "MultiCardPage" });
                self.setState({ doRedirect: true });
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
            }else{}
          } else {
            
            self.setState({ pageName: "TryLinkingAgainPage" });
            self.setState({ doRedirect: true });
          }

        }, (errorResponse) => {
          self.setState({
            showError: false,
            isLoaded: false,
            hyperLink: false,
            contactno:false
           });
           
        
          let error=errorResponse.response;
          const merchantDataForOverlay = getMerchantDataLoginPage(this.state.merchantName)
          if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND) {
            OnLoginTechDiff(this.state.merchantName);
            self.setState({
              doRedirect: false,
              hyperLink: true,
              showError: true,
              disabled: true,
              errMsg: merchantDataForOverlay.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
              userName: "",
              password: ""
            });
            document.getElementById("tryagain-link").focus();
          } else {
            let response = error.data;
            if (response) {
              if (error.status === HttpStatusCode.BAD_REQUEST && response.returnCode === ResultCodes.MANDATORY_FIELD) {
                OnLoginErrorEvent(Messages.INFORM_NOT_MATCH, this.state.merchantName);
                self.setState({
                  doRedirect: false,
                  hyperLink: true,
                  showError: true,
                  disabled: true,
                  errMsg: merchantDataForOverlay.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
                  userName: "",
                  password: "",
                });
              } else if (response.returnCode === ResultCodes.ACCT_ALREADY_LINKED) {
                self.setState({ pageName: "NoEligibleAccountPage" });
                self.setState({ doRedirect: true });
              } else if (response.returnCode === ResultCodes.TECH_DIFF_FI_DOWN || response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
                OnLoginTechDiff(this.state.merchantName);
                self.setState({
                  doRedirect: false,
                  hyperLink: true,
                  showError: true,
                  disabled: true,
                  errMsg: merchantDataForOverlay.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
                  userName: "",
                  password: ""
                });
                document.getElementById("tryagain-link").focus();
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
            } else if (error.statusText === "timeout") {
              OnLoginTechDiff(this.state.merchantName);
              self.setState({
                doRedirect: false,
                hyperLink: true,
                showError: true,
                disabled: true,
                errMsg: merchantDataForOverlay.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
                userName: "",
                password: ""
              });
              document.getElementById("tryagain-link").focus();
            }else {
              OnLoginTechDiff(this.state.merchantName);
              self.setState({
                doRedirect: false,
                hyperLink: true,
                showError: true,
                disabled: true,
                errMsg: merchantDataForOverlay.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
                userName: "",
                password: ""
              });
              document.getElementById("tryagain-link").focus();
            }
          
        }
        }).catch((e)=>{
          OnLoginTechDiff(this.state.merchantName);
          const merchantDataCatch = getMerchantDataLoginPage(this.state.merchantName)
          self.setState({
            doRedirect: false,
            hyperLink: true,
            showError: true,
            disabled: true,
            errMsg: merchantDataCatch.Login.UNABLE_TO_LINK_ERROR_OVERLAY,
            userName: "",
            password: ""
          });
          document.getElementById("tryagain-link").focus();
        });
      }
     else {
      const clientErrMsg = validation.password.message === "" ? validation.userName.message : validation.password.message;
      OnLoginClientErrorEvent(clientErrMsg, this.state.merchantName);
      this.setState({
        showError: false,
        errMsg: "",
        isLoaded: false
      });

    }


  }




  render() {
    const merchantData = getMerchantDataLoginPage(this.state.merchantName)
    let validation = this.state.submitted ?
      this.validator.validate(this.state) :
      this.state.validation




    if (this.state.doRedirect === true) {

      if (this.state.pageName === "SingleCardPage") {
        return <Navigate to={ROUTES.PATH.SingleCardPage} replace />
      } else if (this.state.pageName === "MultiCardPage") {
        return <Navigate to={ROUTES.PATH.MultiCardPage} replace />
      } else if (this.state.pageName === "TryLinkingAgainPage") {
        return <Navigate to={ROUTES.PATH.TryLinkingAgainPage} replace />
      } else if (this.state.pageName === "AccountAlreadyLinkedPage") {
        return <Navigate to={ROUTES.PATH.AccountAlreadyLinkedPage} replace />
      } else if (this.state.pageName === "NoEligibleAccountPage") {
        return <Navigate to={ROUTES.PATH.NoEligibleAccountPage} replace />
      } else if (this.state.pageName === "RaDeny") {
        return <Navigate to={ROUTES.PATH.RaDeny} replace />
      } else if (this.state.pageName === "ContactChannels") {
        return <Navigate to={ROUTES.PATH.ContactChannels} replace />
      }else if (this.state.pageName === "CardSecurePage") {
        return <Navigate to={ROUTES.PATH.CardSecurePage} replace />
      }else if (this.state.pageName === "NoContactChannel") {
        return <Navigate to={ROUTES.PATH.NoContactChannel} replace />
      }else if (this.state.pageName === "MaxProvisionLimitPage") {
        return <Navigate to={ROUTES.PATH.MaxProvisionLimitPage} replace />
      }else if (this.state.pageName === "TechDiff"){
        return <Navigate to={ROUTES.PATH.TechDiff} replace/>
      }else {
        console.log("Route problem")
      }
    } else {

      let isLoadervalue = this.state.isLoaded;
      return (
        <React.Fragment>
          {isLoadervalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner"/>
             </div> : null
          }

          <div className="row">
            <div className="login-blk col-xs-12 col-sm-6  col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              {this.state.showError ? 
                <div className="row login-banner" x-ms-format-detection="none">
                  <div className="col-xs-2 col-sm-2  col-md-2 col-lg-2 banner-img"><img src={alert} class="Alert"  alt="Alert"/></div>
                    <div class="col-xs-10 col-sm-10  col-md-10 col-lg-10 banner-message">{this.state.errMsg}
                     {this.state.hyperLink && !this.state.migrationMessage ? 
                     <button id="tryagain-link" class="changebtnproperty" 
                     onClick={this.OnTryAgain}>Please try again  </button> : null} 
                     {this.state.contactno ? 
                     <div>Please call 1-800-347-2683 to get your account unlocked.</div> : null}</div>
                  </div>:null}
              {this.state.migrationMessage && this.state.hyperLink ? 
                <div className="row migration-login-banner" x-ms-format-detection="none">
                  <div className="col-xs-2 col-sm-2  col-md-2 col-lg-2 banner-img"><img src={alert} class="Alert"  alt="Alert"/></div>
                    <div class="col-xs-10 col-sm-10  col-md-10 col-lg-10 migration-banner-message"> <style class="ErrorMessgeMigration"></style>
                            <p>Discover is now part of Capital One</p>
                            <br></br>
                            <p>Select "Cancel" to return to PayPal, then manually enter your credit card details to add it to your</p>
                            <p>PayPal Wallet</p>
                           </div>
                  </div>:null}
              <div class="login-header">{merchantData.Login.HEADER}</div>
            </div>
          </div>
          <div class="row">
            <div class="login-form-blk col-xs-12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <p class="login-sub-head">{merchantData.Login.SECURE_MESSAGE} <img src={lock} alt="Alert"/></p>
            </div>
          </div>
          <div className="row">
            <div className="login-form-blk col-xs-12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
            <form class="login-form">
                {(this.state.hyperLink && this.state.disabled === false) ||
                (validation.userName.isEmptyValid === true && validation.password.isEmptyValid === true && this.state.disabled===false)
                ? <div className="login-err-msg">Please complete all fields below
                </div> : null}
                <div >
                  <input disabled = {this.state.disabled} maxLength={16} className={this.state.disabled ? 
                    "login-error-greyout" : (this.state.hyperLink || validation.userName.message === "") ? 
                    "login-input": "login-err"} type="text"  name="userName" placeholder="User ID" value={this.state.userName} 
                    onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} />
                  <img hidden={(this.state.hyperLink || validation.userName.message === "") ? true : false} src={alert} alt="Error"/>
                </div>
                {(validation.userName.isEmptyValid === true && validation.password.isEmptyValid === true) ? null :
                  <div className="login-err-msg">{validation.userName.message  ? validation.userName.message:null}</div>}
                <div>
                  <input disabled = {this.state.disabled} className={this.state.disabled ? "login-error-greyout" : (this.state.hyperLink || validation.password.message === "") ? "login-input": "login-err"} type="password"  name="password" autocomplete="off" placeholder="Password" value={this.state.password} onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} />
                  <img hidden={(this.state.hyperLink || validation.password.message === "") ? true : false} src={alert} alt="Error"/>
                </div>
                { (validation.userName.isEmptyValid === true && validation.password.isEmptyValid === true) ? null :
                  <div className="login-err-msg">{validation.password.message ? validation.password.message:null}</div>}
            
              </form>
            </div>
          </div>
          <div className="row">
            <div className="login-form-blk col-xs-12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div class="login-btn">
              {!this.state.hyperLink ?
                <input type="submit" value="Log in" id="log-in-button" onClick={this.handleFormSubmit} /> : ""
              }
                <div class="login-cancel"> <button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
                {!this.state.forgetPasswordDisable ?
                  <div class="login-forgot-pass">  <button class="changebtnproperty"  onClick={this.OnForgotUsername} >Forgot User ID</button> / <button class="changebtnproperty" onClick={this.OnForgotPassword}> Password ? </button></div>
                : ""}
                <div class="login-privacy-use">
                    <button class="changebtnproperty" onClick={this.OnprivacyLink} >Privacy</button> | <button class="changebtnproperty" onClick={this.OntermsUse} >Terms of Use</button> </div>
                </div>
            </div>
          </div>

        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    posts: state
  }
}

export default connect(mapStateToProps)(Login);

